"use client";

import { useEffect } from "react";
import { useLanguageSwitcher, type TranslationLink } from "@contexts/LanguageSwitcherContext";

interface TranslationRegistrarProps {
  urls: TranslationLink[];
}

/**
 * Invisible client component placed inside blog post pages.
 * Registers the post's Polylang translation URLs with the LanguageSwitcherContext
 * so the header language switcher can link to the correct translated slug.
 * Clears the registration when the component unmounts (navigation away).
 */
export default function TranslationRegistrar({ urls }: TranslationRegistrarProps) {
  const { setTranslatedUrls } = useLanguageSwitcher();

  useEffect(() => {
    setTranslatedUrls(urls);
    return () => setTranslatedUrls([]);
  }, [urls, setTranslatedUrls]);

  return null;
}
